const env = (import.meta as any).env ?? {};

const truthy = new Set(["1", "true", "yes", "on"]);

const toBool = (value: unknown): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return false;
  return truthy.has(value.trim().toLowerCase());
};

const globalTrackingEnabled = toBool(env.VITE_TRACKING_ENABLED ?? false);

export const trackingConfig = {
  contentsquare: {
    enabled: globalTrackingEnabled && toBool(env.VITE_CONTENTSQUARE_ENABLED ?? false),
    src: String(env.VITE_CONTENTSQUARE_SRC ?? "").trim(),
  },
  clarity: {
    enabled: globalTrackingEnabled && toBool(env.VITE_CLARITY_ENABLED ?? false),
    projectId: String(env.VITE_CLARITY_PROJECT_ID ?? "").trim(),
  },
};

